'use strict';

/**
 * @generated SignedSource<<483e8173afd8f39788666e601ef1a006>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentFragmentKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "segment"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "variation"
        }
    ], v1 = [
        {
            "alias": "contentFields",
            "args": [
                {
                    "kind": "Variable",
                    "name": "journeyStepId",
                    "variableName": "contentFragmentKey"
                },
                {
                    "kind": "Variable",
                    "name": "segment",
                    "variableName": "segment"
                },
                {
                    "kind": "Variable",
                    "name": "variation",
                    "variableName": "variation"
                }
            ],
            "concreteType": "ContentJourneyDetails",
            "kind": "LinkedField",
            "name": "contentJourneyDetails",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ContentFieldsQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ContentFieldsQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "31ac5dc4143ff57b04c4d830a2482c72",
            "id": null,
            "metadata": {},
            "name": "ContentFieldsQuery",
            "operationKind": "query",
            "text": "query ContentFieldsQuery(\n  $contentFragmentKey: String!\n  $segment: ContentSegment\n  $variation: String\n) {\n  contentFields: contentJourneyDetails(journeyStepId: $contentFragmentKey, segment: $segment, variation: $variation) {\n    key\n    type\n    url\n    value\n  }\n}\n"
        }
    };
})();
node.hash = "bd9c924d0e68d78fe3ec4aa489b8bc23";

module.exports = node;
